import React, { useRef, useEffect } from 'react';
import resume from './files/resume.pdf';

const Profile = () => {


  const appIconStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.3s ease',
    cursor: 'pointer',
    position: 'relative',
    transform: 'scale(1)'
  };

  const imageStyle = {
    width: '30px',
    height: '30px',
    transition: 'transform 0.5s ease',
    marginTop: '4px'
  };

  const labelStyle = {
    position: 'absolute',
    bottom: '100%',
    whiteSpace: 'nowrap',
    fontSize: '12px',
    opacity: 0,
    transition: 'opacity 0.3s ease'
  };

  const toolsContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '16px',
    marginTop: '30px'
  };

  const skillStyle = {
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '4px 8px',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'transform 0.3s ease, margin 0.3s ease'
  };

  const toolsContainerRef = useRef(null);
  const skillsContainerRef = useRef(null);

  const handleInteractionStart = (e) => {
    const icons = toolsContainerRef.current.children;
    const target = e.currentTarget;

    for (let i = 0; i < icons.length; i++) {
      if (icons[i] === target) {
        icons[i].style.transform = 'scale(1.5)';
        icons[i].children[0].style.opacity = 1; // Make label visible
        if (icons[i - 1]) icons[i - 1].style.transform = 'scale(1.2)';
        if (icons[i + 1]) icons[i + 1].style.transform = 'scale(1.2)';
      } else {
        icons[i].children[0].style.opacity = 0; // Hide other labels
      }
    }
  };

  const handleInteractionEnd = () => {
    const icons = toolsContainerRef.current.children;
    for (let i = 0; i < icons.length; i++) {
      icons[i].style.transform = 'scale(1)';
      icons[i].children[0].style.opacity = 0; // Hide label
    }
  };

  const handleSkillInteractionStart = (e) => {
    if (window.innerWidth >= 1024) {
      const skills = skillsContainerRef.current.children;
      const target = e.currentTarget;

      for (let i = 0; i < skills.length; i++) {
        if (skills[i] === target) {
          skills[i].style.transform = 'scale(1.5)';
          skills[i].style.margin = '0 16px';
          if (skills[i - 1]) skills[i - 1].style.marginRight = '24px';
          if (skills[i + 1]) skills[i + 1].style.marginLeft = '24px';
        }
      }
    }
  };

  const handleSkillInteractionEnd = () => {
    const skills = skillsContainerRef.current.children;
    for (let i = 0; i < skills.length; i++) {
      skills[i].style.transform = 'scale(1)';
      skills[i].style.margin = '0 8px';
    }
  };

  useEffect(() => {
    const updateSkillsEffect = () => {
      const skills = skillsContainerRef.current.children;
      if (window.innerWidth < 1024) {
        for (let i = 0; i < skills.length; i++) {
          skills[i].style.transform = 'scale(1)';
          skills[i].style.margin = '0 8px';
        }
      }
    };

    window.addEventListener('resize', updateSkillsEffect);
    updateSkillsEffect();

    return () => {
      window.removeEventListener('resize', updateSkillsEffect);
    };
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ fontSize: '24px', marginBottom: '16px' }}>Profile</h2>
      <div style={{ maxWidth: '100%' }}>
        <div style={{ margin: 'auto', padding: '20px', border: '1px solid #ccc', borderRadius: '20px' }}>
          <p>
            <span style={{ fontSize: '15px', fontWeight: 'bold' }}>I'm Brian Sanchez Ramirez, a software developer and creative technologist from Lima, Peru</span>,
               now based in Utah, USA. With a self-taught background in coding and digital arts, I build efficient, user-focused solutions, blending software 
               development with 3D design expertise. Passionate about innovation, I thrive on turning complex ideas into functional, visually engaging applications. 
               Let's collaborate—reach me at
    
          </p>
          <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center' }}>
            <span>bafsr@proton.me</span>
            <a href={resume} style={{ marginLeft: '8px', fontWeight: 'bold', color: "inherit" }} download>Resume</a>
            <a href='https://link-tree-bafsr.vercel.app/' style={{ marginLeft: '8px', fontWeight: 'bold', color: "inherit" }}>LinkNest</a>
          </div>
        </div>

        {/* Skills Section */}
        <div style={{ marginTop: '40px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '16px' }}>Skills</h2>
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '8px',
              marginTop: '16px',
              padding: '0 8px'
            }}
            ref={skillsContainerRef}
          >
            {/* Skill badges */}
            <span style={skillStyle} onMouseEnter={handleSkillInteractionStart} onMouseLeave={handleSkillInteractionEnd} onTouchStart={handleSkillInteractionStart} onTouchEnd={handleSkillInteractionEnd}>API Integration</span>
            <span style={skillStyle} onMouseEnter={handleSkillInteractionStart} onMouseLeave={handleSkillInteractionEnd} onTouchStart={handleSkillInteractionStart} onTouchEnd={handleSkillInteractionEnd}>3D & Design</span>
            <span style={skillStyle} onMouseEnter={handleSkillInteractionStart} onMouseLeave={handleSkillInteractionEnd} onTouchStart={handleSkillInteractionStart} onTouchEnd={handleSkillInteractionEnd}>Software Development</span>
            <span style={skillStyle} onMouseEnter={handleSkillInteractionStart} onMouseLeave={handleSkillInteractionEnd} onTouchStart={handleSkillInteractionStart} onTouchEnd={handleSkillInteractionEnd}>Concept Design</span>
            <span style={skillStyle} onMouseEnter={handleSkillInteractionStart} onMouseLeave={handleSkillInteractionEnd} onTouchStart={handleSkillInteractionStart} onTouchEnd={handleSkillInteractionEnd}>Performance Optimization</span>
            <span style={skillStyle} onMouseEnter={handleSkillInteractionStart} onMouseLeave={handleSkillInteractionEnd} onTouchStart={handleSkillInteractionStart} onTouchEnd={handleSkillInteractionEnd}>Communication</span>
            <span style={skillStyle} onMouseEnter={handleSkillInteractionStart} onMouseLeave={handleSkillInteractionEnd} onTouchStart={handleSkillInteractionStart} onTouchEnd={handleSkillInteractionEnd}>Brand Development</span>
          </div>
        </div>

        {/* Tools Section with interactive effects */}
        <div style={{ marginTop: '40px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '16px' }}>Tools</h2>
          <div style={toolsContainerStyle} ref={toolsContainerRef}>
            {/* Icons with labels */}
            <div style={appIconStyle} onMouseEnter={handleInteractionStart} onMouseLeave={handleInteractionEnd} onTouchStart={handleInteractionStart} onTouchEnd={handleInteractionEnd}>
              <span style={labelStyle}>Blender</span>
              <img style={imageStyle} src='https://e7.pngegg.com/pngimages/770/966/png-clipart-blender-computer-icons-rendering-blender-3d-computer-graphics-text-thumbnail.png' alt='Blender' />
            </div>
            <div style={appIconStyle} onMouseEnter={handleInteractionStart} onMouseLeave={handleInteractionEnd} onTouchStart={handleInteractionStart} onTouchEnd={handleInteractionEnd}>
              <span style={labelStyle}>Adobe Illustrator</span>
              <img style={imageStyle} src='https://logodownload.org/wp-content/uploads/2017/04/adobe-Illustrator-logo-1-1.png' alt='Adobe Illustrator' />
            </div>
            <div style={appIconStyle} onMouseEnter={handleInteractionStart} onMouseLeave={handleInteractionEnd} onTouchStart={handleInteractionStart} onTouchEnd={handleInteractionEnd}>
              <span style={labelStyle}>Figma</span>
              <img style={imageStyle} src='https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg' alt='Figma' />
            </div>
            <div style={appIconStyle} onMouseEnter={handleInteractionStart} onMouseLeave={handleInteractionEnd} onTouchStart={handleInteractionStart} onTouchEnd={handleInteractionEnd}>
              <span style={labelStyle}>Adobe Photoshop</span>
              <img style={imageStyle} src='https://cdna.artstation.com/p/softwares/icons/000/000/032/default/Photoshop.png?1608144074' alt='Adobe Photoshop' />
            </div>
            <div style={appIconStyle} onMouseEnter={handleInteractionStart} onMouseLeave={handleInteractionEnd} onTouchStart={handleInteractionStart} onTouchEnd={handleInteractionEnd}>
              <span style={labelStyle}>Marvelous Designer</span>
              <img style={imageStyle} src='https://cdna.artstation.com/p/softwares/icons/000/000/056/default/BI_MD_Symbol_Primary.png?1636557207' alt='Marvelous Designer' />
            </div>
            <div style={appIconStyle} onMouseEnter={handleInteractionStart} onMouseLeave={handleInteractionEnd} onTouchStart={handleInteractionStart} onTouchEnd={handleInteractionEnd}>
              <span style={labelStyle}>Visual Studio</span>
              <img style={imageStyle} src='https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Visual_Studio_Icon_2019.svg/512px-Visual_Studio_Icon_2019.svg.png' alt='Visual Studio' />
            </div>
            <div style={appIconStyle} onMouseEnter={handleInteractionStart} onMouseLeave={handleInteractionEnd} onTouchStart={handleInteractionStart} onTouchEnd={handleInteractionEnd}>
              <span style={labelStyle}>React</span>
              <img style={imageStyle} src='https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg' alt='React.js' />
            </div>
            <div style={appIconStyle} onMouseEnter={handleInteractionStart} onMouseLeave={handleInteractionEnd} onTouchStart={handleInteractionStart} onTouchEnd={handleInteractionEnd}>
              <span style={labelStyle}>Three.js</span>
              <img style={imageStyle} src='https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Three.js_Icon.svg/1920px-Three.js_Icon.svg.png' alt='Three js' />
            </div>
          </div>
        </div>

        {/* Experience Section */}
        <div style={{ marginTop: '40px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '16px' }}>Experience</h2>
          <div style={{ spaceY: '16px', marginTop: '16px', paddingBottom: '50px' }}>
            {/* Experience blocks */}
            <div style={{ paddingBottom: '20px' }}>
              <div style={{ border: '1px solid #ccc', padding: '16px', borderRadius: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <p style={{ fontWeight: 'bold' }}>Lead 3D Artist at Bould</p>
                    <p style={{ color: '#787878' }}>Utah, United States of America</p>
                  </div>
                  <div>
                    <p style={{ border: '1px solid #ccc', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>Jan 2023 - Nov 2024</p>
                  </div>
                </div>
                <p style={{ marginTop: '8px' }}>
                - Code optimized software for real-time 3D applications in virtual reality.
                </p>
                <p style={{ marginTop: '8px' }}>
                - Rig and texture 3D assets, integrating them into interactive platforms using game engines.
                </p>
                <p style={{ marginTop: '8px' }}>
                - Enhance performance and scalability for immersive user experiences. 
                </p>
              </div>
            </div>
            <div style={{ paddingBottom: '20px' }}>
              <div style={{ border: '1px solid #ccc', padding: '16px', borderRadius: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <p style={{ fontWeight: 'bold' }}>IT at AcomaEnergy</p>
                    <p style={{ color: '#787878' }}>Texas, United States of America</p>
                  </div>
                  <div>
                    <p style={{ border: '1px solid #ccc', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>January 2024 - Present</p>
                  </div>
                </div>
                <p style={{ marginTop: '8px' }}>
                  - Build web-based software with wordpress for business use.
                </p>
                <p style={{ marginTop: '8px' }}>
                  - Optimize APIs and workflows to support real-time data visualization.
                </p>
              </div>
            </div>
            <div style={{ paddingBottom: '20px' }}>
              <div style={{ border: '1px solid #ccc', padding: '16px', borderRadius: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <p style={{ fontWeight: 'bold' }}>Graphic Designer for Stand120</p>
                    <p style={{ color: '#787878' }}>Lima, Peru</p>
                  </div>
                  <div>
                    <p style={{ border: '1px solid #ccc', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>August 2021 - Present</p>
                  </div>
                </div>
                <p style={{ marginTop: '8px' }}>
                - Develop procedural tools and motion graphics for digital projects.
                </p>
                <p style={{ marginTop: '8px' }}>
                - Prototype software solutions with embedded 3D simulations and visuals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
